module.exports = __webpack_public_path__ + "img/20110201_06.b99166ec.jpg";